/* MACP: Filterwerte sortieren – Marke in fester Reihenfolge, Baureihe natürlich-alphabetisch */
(function(){
  var ORDER=['Mercedes-Benz','Porsche','BMW','Audi'];
  var coll=new Intl.Collator('de',{numeric:true,sensitivity:'base'});
  function key(li){return li.getAttribute('data-macp-label')||li.textContent.trim();}
  function sortList(ul,isMarke){
    var lis=[].slice.call(ul.children).filter(function(n){return n.tagName==='LI';});
    if(lis.length<2)return;
    var sorted=lis.slice().sort(function(a,b){
      var x=key(a),y=key(b);
      if(isMarke){var i=ORDER.indexOf(x),j=ORDER.indexOf(y);if(i<0)i=99;if(j<0)j=99;if(i!==j)return i-j;}
      return coll.compare(x,y);
    });
    var same=sorted.every(function(n,i){return n===lis[i];});
    if(same)return;
    sorted.forEach(function(n){ul.appendChild(n);});
  }
  function run(){
    var seen=new Set();
    document.querySelectorAll('li[data-macp-label]').forEach(function(li){
      var ul=li.parentElement; if(!ul||seen.has(ul))return; seen.add(ul);
      var box=ul.closest('[name]'); var name=(box&&box.getAttribute('name'))||'';
      var isM=(name==='Marke'||name==='Make'||name==='Brand'); if(isM||name==='Baureihe'||name==='Model series'||name==='Series') sortList(ul,isM);
    });
  }
  var t;function later(){clearTimeout(t);t=setTimeout(run,30);}
  document.addEventListener('DOMContentLoaded',run);
  if(document.readyState!=='loading')run();
  new MutationObserver(later).observe(document.documentElement,{childList:true,subtree:true});
})();
